import { SET_VERSION } from '../actions/config';

const initialState = {
    version: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_VERSION:
            return {
                ...state,
                version: action.payload.version
            };
        default: return state;
    }
};